import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found | GradeVIT" description="The requested page does not exist on GradeVIT." keywords="GradeVIT 404" canonicalPath="/404" />
      <section className="elevated space-y-3 rounded-2xl border border-brand-border bg-brand-surface p-6">
        <h1 className="text-2xl font-bold">404 - Page Not Found</h1>
        <p className="text-sm text-brand-muted">The link may be outdated or typed incorrectly.</p>
        <Link to="/" className="inline-block rounded-xl bg-brand-accent px-3 py-2 text-sm font-semibold text-white">Go back home</Link>
      </section>
    </>
  );
}
